<template>
  <div id="user_consents">
    <b-container :fluid="true">
      <b-table :current-page="currentPage"
               :fields="fields"
               :items="user.consents"
               :per-page="perPage"
               head-variant="light"
               hover
               striped
               thead-class="text-center">

        <template v-slot:top-row="{fields}">
          <proposal-filter :id="id"
                           v-model="user.consents"
                           :fields="fields"
                           :not-include-key="['actions','ordinalNumber']"/>
        </template>
        <template v-slot:cell(ordinalNumber)="row">
          <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
        </template>
        <template v-slot:cell(states.state)="row">
          <span v-text="statusMessage(row.item.states.state)"/>
        </template>

        <template v-slot:cell(actions)="row">
          <template v-if="hasHistory(row)">
            <base-action-expand-details :b-table-row="row"/>
          </template>
        </template>

        <template v-slot:row-details="row">
          <b-table :fields="consent_fields"
                   :items="row.item.states.history"
                   hover
                   striped>

            <template v-slot:cell(state)="row">
              <span v-text="stateMessage(row.item.state)"/>
            </template>
          </b-table>
        </template>

      </b-table>

      <b-table-footer v-model="loading"
                      :current-page="currentPage"
                      :data-length="user_consents_length"
                      :per-page="perPage"
                      @change-page="change_page">
        <template v-slot>
          <base-per-page-input v-model="perPage"/>
        </template>
      </b-table-footer>
    </b-container>
  </div>
</template>

<script>
  import BaseActionExpandDetails from '@/components/actions/BaseActionExpandDetails';
  import ProposalFilter from '@/components/ProposalFilter';
  import BTableFooter from '@/components/BTableFooter';
  import { ordinalNumber } from '@/helpers/commonTableColumns';
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';

  export default {
    name: 'user_consents',
    components: {
      BaseActionExpandDetails,
      ProposalFilter,
      BTableFooter,
      BaseColumnOrdinalNumber,
      BasePerPageInput,
    },
    data() {
      return {
        selected_card: 1,
        id: 1,
        user: {},
        loading: true,
        currentPage: 1,
        perPage: 5,
        fields: [
          ordinalNumber,
          {
            key: 'consent_id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'consent_name',
            label: 'Consent name',
            sortable: true,
          },
          {
            key: 'states.date',
            label: 'Date',
            sortable: true,
          },
          {
            key: 'states.state',
            label: 'Status',
            sortable: true,
          },
          'actions',
        ],
        consent_fields: [
          {
            key: 'state',
            label: 'State',
            sortable: true,
          },
          {
            key: 'date',
            label: 'Date',
            sortable: true,
          },
        ],
        disabled: true,
      };
    },
    computed: {
      full_name() {
        return `${this.user.first_name} ${this.user.last_name}`;
      },
      user_consents_length() {
        const { consents = [] } = this.user;
        return consents.length;
      },
    },
    created() {
      this.load_data();
    },
    methods: {
      hasHistory(row) {
        return row.item.states.history.length > 0;
      },
      change_page(val) {
        this.currentPage = val;
      },
      load_data() {
        const user_id = this.$route.params.id;
        this.axios.get(`/users/${user_id}/consents`)
          .then((response) => {
            this.user = response.data;
            this.$emit('setup-proposal', this.user.consents);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      statusMessage(state) {
        return state ? 'Active' : 'Inactive';
      },
      stateMessage(state) {
        return state ? 'Acquired' : 'Resigned';
      },
    },
  };
</script>

<style scoped>
</style>
